import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=5a5de2fa&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5de2fa')) {
      api.createRecord('5a5de2fa', component.options)
    } else {
      api.reload('5a5de2fa', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=5a5de2fa&", function () {
      api.rerender('5a5de2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mtGsiPAh5fBw/JS/comp/costHelpSpa.vue"
export default component.exports